import React from 'react';
import ControlDialog from '../info/control-dialog';
import VideoPopupContent from './video-popup-content';
import css from './video-popup.scss';
const VideoPopup = ({
  isOpen,
  onCloseVideoPopup,
  playedFromUrl
}) => /*#__PURE__*/React.createElement(ControlDialog
// @todo. auto generated. fix this error
// @ts-ignore
, {
  onRequestClose: onCloseVideoPopup,
  content: /*#__PURE__*/React.createElement(VideoPopupContent, {
    onCloseVideoPopup: onCloseVideoPopup,
    playedFromUrl: playedFromUrl
  })
  // @todo. auto generated. fix this error
  // @ts-ignore
  ,
  bodyClassName: css.bodyClassName
  // @todo. auto generated. fix this error
  // @ts-ignore
  ,
  contentClassName: css.contentClassName
  // @todo. auto generated. fix this error
  // @ts-ignore
  ,
  dialogClass: css.dialogClass
  // @todo. auto generated. fix this error
  // @ts-ignore
  ,
  overlayClassName: css.overlayClassName,
  open: isOpen,
  showCloseButton: false
  // @todo. auto generated. fix this error
  // @ts-ignore
  ,
  dataPopup: "VideoPopupContent"
});
export default VideoPopup;